// extracted by mini-css-extract-plugin
export default {"cluster":"styles-module__cluster__SxpNU","text":"styles-module__text__q3dQB","icon":"styles-module__icon__MScvU","hovered":"styles-module__hovered___I5BC"};